<mwe-modal [model]="popupModel()">
  <h3 class="mb-4">{{ 'products.cancellation.title' | translate }}</h3>
  <h4 class="mb-4">{{ 'products.cancellation.subtitle' | translate }}</h4>
  <div class="row g-4">
    <div class="col-lg-6">
      <mwe-clickable-products-card
        (cardClicked)="startDefaultCancellation()"
        [categories]="[Sparte.Strom, Sparte.Gas, Sparte.Fernwaerme]"
        [hasAutoFocus]="true"
        dataTest="cancel-products-default"
        ariaTitle="move-out.title"
      >
        <p class="text--legal mb-1">
          <span class="fw-semibold mb-0" translate="products.orderProducts.popup.newClient.stromGas"></span> {{ stromCompany() }}
        </p>
        <p class="text--legal mb-0">
          <span class="fw-semibold" translate="products.orderProducts.popup.newClient.waerme"></span> {{ waermeCompany() }}
        </p>
      </mwe-clickable-products-card>
    </div>

    <div class="col-lg-6">
      <mwe-clickable-products-card
        (cardClicked)="startEmobCancellation()"
        [categories]="[Sparte.Emobility]"
        dataTest="cancel-products-emobility"
        ariaTitle="emobCancellation.title"
      >
        <p class="text--legal mb-0">{{ emobilityCompany() }}</p>
      </mwe-clickable-products-card>
    </div>
  </div>
</mwe-modal>
